import { render, staticRenderFns } from "./TargetItems.vue?vue&type=template&id=82478472&scoped=true"
import script from "./TargetItems.vue?vue&type=script&lang=js"
export * from "./TargetItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82478472",
  null
  
)

export default component.exports